import { $sso } from '../main'
import { createProvider } from '../vue-apollo'
import { onError } from 'apollo-link-error'
import store from '../store'

const link = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors)
    graphQLErrors.map(({ message, path }) => {
      if (
        path?.includes('checkUnhandledDuaMessages') &&
        message === 'Request failed with status code 503'
      ) {
        return
      }

      if (path && !path.includes('login')) {
        if (message === 'Not authorized') {
          $sso.logout()
        } else {
          store.state.app.errors = graphQLErrors.map(x => x.message)
          store.state.app.showErrorModal = true
        }
      }
    })

  if (networkError) {
    if (networkError.result) {
      if (
        networkError.result.errors.some(
          x => x.extensions.code === 'UNAUTHENTICATED'
        )
      ) {
        $sso.logout()
        return
      }

      store.state.app.errors = networkError.result.errors.map(x => x.message)
    } else if (networkError.message) {
      store.state.app.errors = [networkError.message]
    } else {
      store.state.app.errors = [networkError.stack]
    }

    store.state.app.showErrorModal = true
  }
})

export default createProvider({ link })
